<template>
  <div class="_4screen ">
    <div class="_4screen__item">
      <calendar />
    </div>
    <div class="_4screen__item">
      <calendar-week />
    </div>
    <div class="_4screen__item">
      <masters :isMap="true" />
      <!-- <map-employee typeMap="masters" /> -->
    </div>
    <div class="_4screen__item">
      <orders />
    </div>
  </div>
</template>

<script>
import calendarWeek from '@/components/calendars/week/calendarWeek'
import calendar from './calendar'
import orders from './orders'
import masters from './masters/index'

export default {
    components: {
        calendar, orders, calendarWeek, masters,
    },
}
</script>

<style lang="scss">
// @import "src/assets/sass/main";
// @import "src/assets/sass/style";

._4screen {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-wrap: wrap;
  position: fixed;
  z-index: 99999999999;
  left: 0;
  top: 0;
  background-color: var(--bg-color2);

  &__item {
    width: calc(50vw - 60px);
    height: calc(50vh - 60px);
    margin: 30px;
    overflow: hidden;

    .main-layout__map_absolute {
      height: calc(50vh - 60px) !important;
    }
  }
}
</style>
